import { memo, useRef } from 'react'

import { IS_RTL_DIRECTION } from 'consts'

import * as Styled from './styled'

interface IProps {
  text?: string
  onClick: (name: string) => void
  isActive: boolean
  name: string
  tabWidth: number
  areHoverStylesUnset?: boolean
  height: number
}

const FlatTab: React.FC<IProps> = ({
  text,
  onClick,
  isActive,
  name,
  tabWidth,
  areHoverStylesUnset,
  height
}) => {
  const tabRef = useRef<HTMLDivElement | null>(null)

  return (
    <Styled.FlatTab
      ref={tabRef}
      onClick={() => onClick(name)}
      $tabWidth={tabWidth}
      $isActive={isActive}
      $isRTLDirection={IS_RTL_DIRECTION}
      $areHoverStylesUnset={areHoverStylesUnset}
      $height={height}
    >
      <Styled.Text
        color={isActive ? 'primaryDark' : 'secondary'}
        type={isActive ? 'h3' : 'h4'}
        $isActive={isActive}
      >
        {text}
      </Styled.Text>
    </Styled.FlatTab>
  )
}

export default memo(FlatTab)
